import { Component, Input,OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { BlockGroupService } from '../../../../../app/services/block.group.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { BindComponentService } from '../../../../utils/bind.component.service';
/**
 * @version $Id: content.component.ts 82524 2018-03-18 23:37:08Z thiago.h.neri $
 */
@Component({
  selector: 'configureBlockingModal',
  templateUrl: './content.template.html'
})
export class ConfigureBlockingModalComponent implements OnInit {

  private static readonly ACTION_BLOCK = 'blockLines';
  private static readonly ACTION_UNBLOCK = 'unBlockLines';

  @Input() group: DataPackGroup;
  @Input() lines: Set<string> = new Set<string>();
  @Input() configSMS: boolean;
  @Input() blockLines: boolean;
  @Input() lineAcountList: any[];
  @Input() dataPackLine: DataPackLine = new DataPackLine();
  private action: string='';
  private saving: boolean;

  constructor(private bindComponent: BindComponentService,private activeModal: NgbActiveModal, private blockGroupService: BlockGroupService, private alertService: AlertService) {

  }



  ngOnInit() {
    if (this.lineAcountList != null && this.lineAcountList.length === 1) {
      this.action = this.dataPackLine.blockedSMS ? "ACT" : "DES" ;
    }
    if (this.lineAcountList != null && this.lineAcountList.length === 1) {
      this.action = this.dataPackLine.blockedManager ? "52" : "51" ;
    }
  }

  private close() {
    this.activeModal.dismiss();
  }

  private apply() {
    this.saving = true;
    let payload = {
      action: this.action,
      sourceGroup: {
        id: this.group.id
      },
      lines: []
    };
    this.lines.forEach((line: string) => {
      payload.lines.push({
        lineNumber: line
      });
    });
    let promise = this.action === ConfigureBlockingModalComponent.ACTION_BLOCK ? this.blockGroupService.blockLines(payload) : this.blockGroupService.unblockLines(payload);
    promise.subscribe(
      data => {
        this.saving = false;
        this.alertService.success(data['result']);
        this.activeModal.close(this.action);
      },
      err => {
        this.saving = false;
        this.alertService.error(err.result, err);
        this.activeModal.dismiss();
      }
    );
  }

  public activateBloqueioSMS(){
    this.blockGroupService.configSMS(this.action,this.lineAcountList).subscribe(
      data => {
        this.activeteSucess();
      },
      err => {
        this.activeteError(err);
      }
    );
  }

  public activeteSucess(){
    this.alertService.success("Atualizado com sucesso!");
    this.saving = false;
    this.activeModal.close(this.action);
    this.bindComponent.set(BindComponentService.LOAD_VIEW_BLOCK_VOICE, true);
  }
  public activeteError(err: any){
    this.saving = false;
    this.alertService.error(err.result, err);
    this.activeModal.dismiss();
    this.bindComponent.set(BindComponentService.LOAD_VIEW_BLOCK_VOICE, true);
  }
  
  public activateBloqueioGestor(){
	this.blockGroupService.configManager(this.action,this.lineAcountList).subscribe(
	  data => {
	    this.activeteSucess();
	  },
	  err => {
      this.activeteError(err);
	  }
	);
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/configure/content.component.ts